import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "simbad-resolver" }

import {ref} from 'vue';
import { simbadNameResolver, ResolvedObject} from './simbad_resolvers';
import { sesameNameResolver } from './sesame_resolver';
import { engineStore } from '@wwtelescope/engine-pinia';
import { D2R } from "@wwtelescope/astro";

interface SesameResolverComonentProps {
  goto?: boolean,
  button?: boolean,
  buttonColor?: string
}
const resolver: 'sesame' | 'simbad' | 'fallback' = 'fallback';

export default /*@__PURE__*/_defineComponent({
  __name: 'SimbadResolver',
  props: {
    goto: { type: Boolean, default: false },
    button: { type: Boolean, default: false },
    buttonColor: { default: 'on-surface' }
  },
  emits: ["resolved"],
  setup(__props: any, { emit: __emit }) {

const store = engineStore();

const props = __props;

const emits = __emit;

  
const name = ref<string | null>(null);
const details = ref<ResolvedObject | null>(null);
const errorMessage = ref('');

const searching = ref(false);
function simbadWithSesameFallback(name) {
  return simbadNameResolver(name).catch(() => sesameNameResolver(name));
}
const resolvers = {
  'sesame': sesameNameResolver,
  'simbad': simbadNameResolver,
  'fallback': simbadWithSesameFallback,
};

function goTo(object: ResolvedObject) {
  if (object?.raDeg && object?.decDeg) {
    console.log(`Going to ${object.raDeg}d ${object.decDeg}d`);
    store.gotoRADecZoom({
      raRad: object.raDeg * D2R,
      decRad: object.decDeg * D2R,
      zoomDeg: 30,
      instant: false,
    });
  }
}


function resolveName() {
  console.log(`resolving ${name.value}`);
  errorMessage.value = '';
  if (name.value) {
    searching.value = true;
    (resolvers[resolver])(name.value)
      .then(d => {
        details.value = d;
        emits('resolved', d);
        searching.value = false;
        if (props.goto) {
          goTo(d);
        }
      })
      .catch((e) => {
        console.log(e);
        searching.value = false;
        errorMessage.value = 'Could not find object';
      });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_text_field, {
      modelValue: name.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
      class: "simbad-resolver-text-field",
      style: {"pointer-events":"auto"},
      label: "Object name",
      density: "compact",
      "bg-color": "black",
      variant: "outlined",
      "error-messages": errorMessage.value,
      "persistent-hint": "",
      hint: "Press [Enter] to search",
      onKeyup: _withKeys(resolveName, ["enter"]),
      onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      autocorrect: "off"
    }, null, 8, ["modelValue", "error-messages"]),
    (__props.button)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          onClick: _cache[2] || (_cache[2] = () => resolveName()),
          loading: searching.value,
          color: __props.buttonColor,
          text: "Search",
          type: "Submit",
          density: "comfortable",
          class: "mt-1"
        }, null, 8, ["loading", "color"]))
      : _createCommentVNode("", true)
  ]))
}
}

})